// 公共逻辑 商品订单排行榜

import { useGoodServer, useMsgServer } from 'middle-domain';
import { formatAmountToW } from '@/app-shared/utils/amountUtils';
import truncateText from '@/app-shared/utils/truncateText';

export default {
  data() {
    return {
      rankList: [],
      openOrderRankSwitch: false
    };
  },
  beforeCreate() {
    this.msgServer = useMsgServer();
    this.goodsServer = useGoodServer();
  },
  created() {
    this.permissionValueObj['ui.order_rank_switch'] && this.getShopRankList();
    this.msgServer.$onMsg('ROOM_MSG', msg => {
      console.log('shopOrderRankMixin msg', msg);
      // 商品订单排行榜消息
      if (msg?.data?.type === 'yz_shop_ranking') {
        this.handleRankList(msg?.data?.list || []);
      } else if (msg?.data?.type === 'permission_change_notice') {
        // "type": "permission_change_notice",    # 消息类型
        // "webinar_id": 111111,                  # 所属活动
        // "permission_key": "order_rank_switch", # 更新的配置项 key
        // "permission_val": 1 # 更新后的配置项值
        if (msg?.data?.permission_key === 'ui.order_rank_switch') {
          this.openOrderRankSwitch = msg?.data?.permission_val + '' === '1';
          if (this.openOrderRankSwitch) {
            this.getShopRankList();
          }
        }
      }
    });
  },
  computed: {
    webinarId() {
      return this.$domainStore.state.roomBaseServer?.watchInitData?.webinar?.id;
    },
    // 活动状态（2-预约 1-直播 3-结束 4-点播 5-回放）
    webinarType() {
      return Number(this.$domainStore.state.roomBaseServer?.watchInitData?.webinar?.type);
    },
    showRankList() {
      return !!(
        this.rankList?.length &&
        this.rankList?.length === 3 &&
        [1].includes(this.webinarType) &&
        this.openOrderRankSwitch
      );
    },
    permissionValueObj() {
      return this.$domainStore.state.roomBaseServer?.permissionValueObj || {};
    }
  },
  watch: {
    permissionValueObj: {
      handler(newVal) {
        this.openOrderRankSwitch = newVal['ui.order_rank_switch'] + '' === '1';
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getShopRankList() {
      let opt = {
        webinar_id: this.webinarId
      };
      this.goodsServer?.getShopRankList(opt).then(res => {
        if (res?.code === 200) {
          let list = res?.data || [];
          // list = [
          //   {
          //     shop_code: 1,
          //     shop_name: '多发大水发地方1',
          //     total_amount: 1000
          //   },
          //   {
          //     shop_code: 2,
          //     shop_name: '多发大水发地方2',
          //     total_amount: 2000
          //   },
          //   {
          //     shop_code: 3,
          //     shop_name: '多发大水发地方3',
          //     total_amount: 999999
          //   }
          // ];
          this.handleRankList(list);
        }
      });
    },
    handleRankList(list = []) {
      // shop_code	string 店铺编码
      // shop_name	string 店铺名称
      // total_amount	number 总销售金额，单位分
      if (!Array.isArray(list)) return;
      list.forEach(item => {
        item.totalAmountStr = formatAmountToW(item.total_amount / 100);
        item.shopNameStr = truncateText(item?.shop_name, 10);
      });
      this.rankList = list.slice(0, 3);

      this.adaptStyle();
    },
    show(visible = false) {
      if (visible) {
        this.getShopRankList();
      } else {
        // 隐藏
        this.rankList = [];
      }
    }
  }
};
